"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _Link = _interopRequireDefault(require("@material-ui/icons/Link"));

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

var _DarkMuiThemeProvider = _interopRequireDefault(require("../DarkMuiThemeProvider"));

var _useProductData = require("../Product/useProductData");

var _FabricateForm = _interopRequireDefault(require("./FabricateForm"));

var _excluded = ["fabricate", "actionBar", "onPropChange", "onSetPdfRef", "onPreviewFabricate", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    fileListItemWrapper: {
      width: '88%'
    },
    pdfRefItemWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: '12%',
      height: 48
    }
  };
});

var EditFabricateSheet = function EditFabricateSheet(_ref) {
  var fabricate = _ref.fabricate,
      actionBar = _ref.actionBar,
      onPropChange = _ref.onPropChange,
      onSetPdfRef = _ref.onSetPdfRef,
      onPreviewFabricate = _ref.onPreviewFabricate,
      labels = _ref.labels,
      other = _objectWithoutProperties(_ref, _excluded);

  var _usePublishedProductD = (0, _useProductData.usePublishedProductData)(product, fabricate.productType),
      formJSON = _usePublishedProductD.formJSON,
      formUIJSON = _usePublishedProductD.formUIJSON;

  if (fabricate == null) {
    return null;
  }

  var _fabricate$data = fabricate.data,
      code = _fabricate$data.code,
      name = _fabricate$data.name,
      description = _fabricate$data.description,
      specification = _fabricate$data.specification;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_DarkMuiThemeProvider["default"], null, /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, {
    position: "static",
    title: /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
      flexDirection: "column"
    }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "heading",
      color: "inherit",
      noWrap: true
    }, code), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "title",
      color: "inherit",
      noWrap: true
    }, name)),
    extraToolbar: actionBar,
    actions: /*#__PURE__*/_react["default"].createElement(_core.Box, {
      display: "flex",
      width: "100%",
      justifyContent: "flex-end"
    }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      onClick: function onClick() {
        return onPreviewFabricate();
      }
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], null)))
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, "pvjdspovs", labels.info), /*#__PURE__*/_react["default"].createElement(_FabricateForm["default"], {
    data: fabricate.data,
    formJSON: formJSON,
    formUIJSON: formUIJSON,
    onChange: onPropChange,
    readonly: true
  }), /*#__PURE__*/_react["default"].createElement(TechnicalSheetItem, {
    title: labels.technicalSheetRef,
    technicalSheetRef: fabricate.technicalSheetRef,
    technicalSheetMetadata: {
      fabricateId: fabricate._id
    },
    onSetPdfRef: onSetPdfRef('technicalSheetRef'),
    labels: labels.pageRef
  }), /*#__PURE__*/_react["default"].createElement(TechnicalSheetItem, {
    title: labels.restrictedTechnicalSheetRef,
    technicalSheetRef: fabricate.restrictedTechnicalSheetRef,
    technicalSheetMetadata: {
      fabricateId: fabricate._id
    },
    onSetPdfRef: onSetPdfRef('restrictedTechnicalSheetRef'),
    labels: labels.pageRef
  }), /*#__PURE__*/_react["default"].createElement(_ui.DocumentManagement, _extends({
    images: fabricate.images,
    documents: fabricate.documents,
    acl: fabricate.acl,
    labels: _objectSpread(_objectSpread({}, labels.docs), {}, {
      acl: labels.acl
    })
  }, other))));
};

var TechnicalSheetItem = function TechnicalSheetItem(_ref2) {
  var title = _ref2.title,
      technicalSheetRef = _ref2.technicalSheetRef,
      technicalSheetMetadata = _ref2.technicalSheetMetadata,
      onSetPdfRef = _ref2.onSetPdfRef,
      labels = _ref2.labels;
  var classes = useStyles();

  if (technicalSheetRef == null) {
    return null;
  }

  var document = technicalSheetRef.document,
      startPage = technicalSheetRef.start.page,
      endPage = technicalSheetRef.end.page;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, title), /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.fileListItemWrapper
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
    label: "".concat(document.fileName, " - ").concat(document.version),
    description: startPage > -1 ? labels.pages({
      start: startPage + 1,
      end: endPage + 1
    }) : labels.empty,
    fileUrl: document.src,
    onClickDownloadFile: function onClickDownloadFile() {
      return window.open(document.src, '__blank');
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.pdfRefItemWrapper
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "add-pdf-ref",
    "aria-controls": "add-pdf-ref-menu",
    "aria-haspopup": "true",
    onClick: function onClick() {
      return onSetPdfRef(document._id, document.src, startPage, endPage, technicalSheetMetadata, labels);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], null))))));
};

var _default = EditFabricateSheet;
exports["default"] = _default;